import { IconInfoCircle } from "@tabler/icons-react";
import { InfoIcon } from "src/components/UI/Icon/InfoIcon";
import { useDeviceContext } from "src/context/device-context";
import DangerIcon from "../Icon/DangerIcon";
import classes from "./FormInfoElement.module.css";

function getClassByType(type) {
  switch (type) {
    case "notice":
      return classes.notice;
    case "warning":
      return classes.warning;
    default:
      return classes.info;
  }
}

export function FormInfoElement({ children, type = "info" }) {
  const { isMobile } = useDeviceContext();
  return (
    <div
      className={`${classes.information} ${
        isMobile ? classes.mobile : classes.desktop
      } ${getClassByType(type)}`}>
      {type === "info" && <InfoIcon size={16} />}
      {type === "notice" && <IconInfoCircle color="var(--text-4)" size={18} />}
      {type === "warning" && <DangerIcon size={20} />}
      <span>{children}</span>
    </div>
  );
}
